import script from "./ColorOption.vue?vue&type=script&setup=true&lang=js"
export * from "./ColorOption.vue?vue&type=script&setup=true&lang=js"

import "./ColorOption.vue?vue&type=style&index=0&id=55e31677&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-55e31677"]])

export default __exports__